import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  return (
    <footer className="bg-[#2c3e50] text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center p-2">
                <img src="https://customer-assets.emergentagent.com/job_harmony-behavioral/artifacts/rov8cr92_HHW_icon.jpg" alt="Harmony Logo" className="h-full w-full object-contain" />
              </div>
              <div>
                <h3 className="text-lg font-bold">Harmony Behavioral &</h3>
                <h3 className="text-lg font-bold">Psychiatric Health</h3>
              </div>
            </div>
            <p className="text-white/80 text-sm mb-4">Evidence informed care for your mental wellness journey</p>
            <div className="space-y-2 text-sm">
              <p className="flex items-start gap-2 text-white/80">
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <span>1123 Clairmont Rd<br />Decatur, GA 30030</span>
              </p>
              <a href="https://instagram.com/harmonyhealthwell" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/80 hover:text-[#c9b17a] transition-colors">
                <Instagram size={16} />
                <span>@harmonyhealthwell</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/80 hover:text-[#c9b17a] transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-[#c9b17a] transition-colors">Services</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-[#c9b17a] transition-colors">About</Link></li>
              <li><Link to="/resources" className="text-white/80 hover:text-[#c9b17a] transition-colors">Resources</Link></li>
              <li><Link to="/crisis-resources" className="text-white/80 hover:text-[#c9b17a] transition-colors">Crisis Resources</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 mb-6">
              <a href="tel:404-738-7542" className="flex items-center gap-2 text-white/80 hover:text-[#c9b17a] transition-colors">
                <Phone size={18} />
                <span>404-738-7542</span>
              </a>
              <div className="flex items-center gap-2 text-white/80">
                <Mail size={18} />
                <span>Fax: 678-737-1486</span>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8">
          <Link to="/book-appointment">
            <Button size="lg" className="bg-[#c9b17a] hover:bg-[#b89d66] text-white font-semibold shadow-lg rounded-lg">
              Now Accepting New Clients — Book Today
            </Button>
          </Link>
        </div>

        <div className="border-t border-white/20 pt-6">
          <div className="text-center text-sm text-white/60">
            <p className="mb-2"><strong>Notice:</strong> This practice maintains strict privacy policies in accordance with HIPAA regulations.</p>
            <p className="mb-2">
              <Link to="/medical-disclaimer" className="text-white/80 hover:text-[#c9b17a] transition-colors">Medical Disclaimer</Link>
              {' | '}
              <Link to="/terms-of-service" className="text-white/80 hover:text-[#c9b17a] transition-colors">Terms of Service</Link>
              {' | '}
              <Link to="/privacy-policy" className="text-white/80 hover:text-[#c9b17a] transition-colors">Privacy Policy</Link>
            </p>
            <p>© {new Date().getFullYear()} Harmony Behavioral & Psychiatric Health. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;